import * as PIXI from "pixi.js";
import Layers from "../../layers/Layers";
import SwitcherAnimation from "../../animation/SwitcherAnimation";

const BUTTON_X = 10

export default class Switcher extends PIXI.Container {
  private Layers = Layers.getInstance();
  private isActive: boolean = false;
  private greenBg: PIXI.Graphics;
  private grayBg: PIXI.Graphics;
  private button: PIXI.Graphics;
  private handleSwitch: (isActive: boolean) => void;
  constructor(color: number, handleSwitch: (isActive: boolean) => void, isAddCon: boolean = false) {
    super();
    this.handleSwitch = handleSwitch;
    this.greenBg = this.addBg(color);
    this.grayBg = this.addBg(0xDEDEDE);
    this.addButton(0xFFFFFF);
    this.addInteractivity();
    !isAddCon && this.addToLayer();
  }
  private addToLayer = () => this.Layers.UI.addChild(this);
  getActive = () => this.isActive;

  private addBg(color: number) {
    const bgBound = { width: 40, height: 20 }
    const bg = new PIXI.Graphics()
      .clear()
      .roundRect(-bgBound.width / 2, -bgBound.height / 2, bgBound.width, bgBound.height)
      .fill(color)
    this.addChild(bg);
    return bg;
  }
  handleSwitchButton() {
    this.isActive = !this.isActive;
    this.handleSwitch(this.isActive);
    new SwitcherAnimation(this);
  }
  private addInteractivity() {
    this.interactive = true;
    this.cursor = "pointer";
    this.on("mouseup", () => this.handleSwitchButton())
    this.on("touchend", () => this.handleSwitchButton())
  }
  setActive(v: number) {// using on SwitcherAnimation.ts
    this.grayBg.alpha = this.isActive ? 1 - v : v;
    this.greenBg.alpha = this.isActive ? v : 1 - v;
    this.button.x = this.isActive ? (2 * BUTTON_X) * v : (2 * BUTTON_X) * (1 - v);
  }
  private addButton(color: number) {
    this.button = new PIXI.Graphics()
      .circle(-BUTTON_X, 0, 8)
      .fill(color)
    this.addChild(this.button);
  }
}